import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import User from '_class/User';
import { getRootUrl } from 'helpers/url';
import { PRESCHOOL } from 'constants/schoolTypes';
import { getUserAttendance, clearUserAttendance } from 'actions/absence';
import { getScheduleForUser, getActivitiesForMe, getActivitesForGroups, getActivitiesById, getScheduleForGroups, clearActivitesForOther } from 'actions/schedule';
import SelectLinkedPosition from 'containers/Schedule/SelectLinkedPosition';
import { translate as getTranslate, getActiveLanguage, Icon } from '@haldor/ui';
import SelectionDisplay from './Partials/SelectionDisplay';
import ItemContent from './Partials/ItemContent';
import { Button } from '@haldor/ui';
import './_Schedule.scss';

var MonthHeader = function MonthHeader(_ref) {
  var label = _ref.label;
  var test = moment().local().format('dddd');
  return /*#__PURE__*/React.createElement("span", {
    role: "columnheader",
    "aria-sort": "none",
    className: test == label.toLowerCase() ? 'todaysMonth' : ''
  }, label);
};

var filterMonth = function filterMonth(data, date) {
  var groups = {};
  var start = moment(date).startOf('month').set({
    hour: 0,
    minute: 0,
    second: 0
  });
  var end = moment(date).endOf('month').set({
    hour: 23,
    minute: 59,
    second: 59
  });
  data.forEach(function (item) {
    var timestamp = moment.utc(item.startTime).startOf('day').local();
    var date = timestamp.toISOString();

    if (timestamp.isBetween(start, end)) {
      if (date in groups) {
        groups[date].push(item);
      } else {
        groups[date] = new Array(item);
      }
    }
  });
  var ars = [];

  for (var _i = 0, _Object$entries = Object.entries(groups); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    ars.push(_defineProperty({}, key, _toConsumableArray(value)));
  }

  return ars;
}; //Filter array by filtertags for assignment types


var filterArray = function filterArray(arr, data, tags, isAdvanced) {
  var isStudent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var tempArr = [];

  if (isStudent) {
    tempArr = arr;
  } //retrive booked meetings if user has checked the choice


  if (data !== null && data !== void 0 && data.booked && data !== null && data !== void 0 && data.Meeting) {
    var bookedMeetings = arr.filter(function (item) {
      return item.type === 'Meeting' && item.instanceId != null;
    });
    tempArr = [].concat(_toConsumableArray(tempArr), _toConsumableArray(bookedMeetings));
  } //retrive unbooked meetings if user has checked the choice


  if (data !== null && data !== void 0 && data.unBooked && data !== null && data !== void 0 && data.Meeting && !isAdvanced) {
    var unbook = [];

    for (var i = 0; i < arr.length; i++) {
      if (arr[i].type === 'Meeting' && arr[i].instanceId === null) {
        unbook.push(arr[i]);
      }
    }

    tempArr = [].concat(_toConsumableArray(tempArr), unbook);
  }

  if (isStudent && !data.Meeting) {
    var removeMeeting = tempArr.filter(function (x) {
      return (x === null || x === void 0 ? void 0 : x.type) !== 'Meeting';
    });
    tempArr = removeMeeting;
  }

  if (data.Assignment && !isStudent) {
    var assignmentTypes = arr.filter(function (item) {
      return tags.find(function (f) {
        return f.name === (item === null || item === void 0 ? void 0 : item.instanceType);
      });
    });
    tempArr = [].concat(_toConsumableArray(tempArr), _toConsumableArray(assignmentTypes));
  } else if (isStudent && !data.Assignment) {
    var removeAssignments = tempArr.filter(function (x) {
      return (x === null || x === void 0 ? void 0 : x.type) !== 'Assignment';
    });
    tempArr = removeAssignments;
  }

  return tempArr;
};

var countActivities = function countActivities(data) {
  var count = {};
  var assignment = 0;
  var meetings = 0;
  var unBooked = 0;
  var lesson = 0;
  data.forEach(function (element) {
    if (element.type === 'Meeting' && element.instanceId == null) {
      unBooked++;
    } else if (element.type === 'Meeting' && element.instanceId) {
      meetings++;
    } else if (element.instanceType) {
      assignment++;
      count[element.instanceType] = (count[element.instanceType] || 0) + 1;
    } else {
      lesson++;
    }
  });
  count.Assignment = assignment;
  count.meetings = meetings;
  count.unBooked = unBooked;
  count.lesson = lesson;
  return count;
};

var handleScheduleGroupData = function handleScheduleGroupData() {
  var _peopleArr;

  var sections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var peopleArr = [];
  sections.forEach(function (items) {
    var arr = [].concat(_toConsumableArray(items === null || items === void 0 ? void 0 : items.students), _toConsumableArray(items === null || items === void 0 ? void 0 : items.owners));
    peopleArr = [].concat(_toConsumableArray(peopleArr), _toConsumableArray(arr));
  });
  var removeSame = (_peopleArr = peopleArr) === null || _peopleArr === void 0 ? void 0 : _peopleArr.filter(function (item, index, self) {
    return self.findIndex(function (t) {
      return t.id === item.id;
    }) === index;
  });
  return removeSame;
};

var removedDuplicates = function removedDuplicates() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var data2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var combined = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (data.length > 0 && (data2 === null || data2 === void 0 ? void 0 : data2.length) > 0) {
    if (combined) {
      var removeOwnedItems = data.filter(function (item) {
        return !data2.find(function (f) {
          return f.id == (item === null || item === void 0 ? void 0 : item.id);
        });
      });
      return removeOwnedItems;
    }

    var findUnique = data.filter(function (item) {
      return !(data2 !== null && data2 !== void 0 && data2.find(function (f) {
        return f.id == (item === null || item === void 0 ? void 0 : item.id);
      }));
    });
    var removeSame = findUnique === null || findUnique === void 0 ? void 0 : findUnique.filter(function (item, index, self) {
      return self.findIndex(function (t) {
        return t.id === item.id && t.type === item.type;
      }) === index;
    });
    return removeSame;
  }

  return data;
};

var setLocalizer = function setLocalizer() {
  moment.locale(getActiveLanguage());
  return momentLocalizer(moment);
};

var ScheduleView = function ScheduleView(props) {
  var _props$view2;

  var dispatch = useDispatch(); //Data sections

  var currentUser = useSelector(function (state) {
    return state.user.currentUser;
  });
  var activities = useSelector(function (state) {
    return state.schedule.userActivites;
  });
  var schedules = useSelector(function (state) {
    return state.schedule.usersSchedule;
  });
  var groupActivites = useSelector(function (state) {
    return state.schedule.groupActivities;
  });
  var attendance = useSelector(function (state) {
    return state.Absence.userAttendance;
  });
  var groupSchedules = useSelector(function (state) {
    return state.schedule.groupSchedules;
  });
  var loggedInUser = useMemo(function () {
    return new User(currentUser);
  }, []);
  var school = useSelector(function (state) {
    return state.user.activeSchool;
  });
  var studentActivites = useSelector(function (state) {
    return state.schedule.studentActivities;
  });
  var service = useSelector(function (state) {
    return state.Services.availableServices;
  });
  var ScheduleFilter = useSelector(function (state) {
    return state.ScheduleFilter;
  });
  var translate = getTranslate(useSelector(function (state) {
    return state.Languages.translations;
  })); //states

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      linkedPosition = _useState4[0],
      setLinkedPosition = _useState4[1];

  var _useState5 = useState(activities),
      _useState6 = _slicedToArray(_useState5, 2),
      filterData = _useState6[0],
      setFilterData = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      customButton = _useState8[0],
      setCustomButton = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      displayWholeDay = _useState10[0],
      setDisplayWholeDay = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      storedFilterData = _useState12[0],
      setStoredFilterData = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      othersFilteredData = _useState14[0],
      setOthersFilteredData = _useState14[1];

  var notOwnedActivities = useMemo(function () {
    if (ScheduleFilter.advancedCalendarActive && !props.noAdvanced) {
      return removedDuplicates(groupActivites, activities);
    }
  }, [groupActivites, activities, ScheduleFilter.advancedCalendarActive, props.noAdvanced]);

  var _useState15 = useState([]),
      _useState16 = _slicedToArray(_useState15, 2),
      buttonCoords = _useState16[0],
      setButtonCords = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      timeButtonOpen = _useState18[0],
      setTimeButtonOpen = _useState18[1]; //useRefs


  var containerRef = useRef(null);
  var hasFetchedGroups = useRef({
    tasks: false,
    schedules: false
  });
  var hasFetcheMySchedule = useRef({
    tasks: false,
    schedules: false
  });
  var finishedLoading = useRef(true);

  var _useState19 = useState([]),
      _useState20 = _slicedToArray(_useState19, 2),
      storedOtherSchedules = _useState20[0],
      setStoredOtherSchedules = _useState20[1];

  var history = useHistory();
  var localizer = useMemo(function () {
    return setLocalizer();
  }, [getActiveLanguage]);
  var userId = props.userId != null ? props.userId : currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;
  var notOwnedSchedules = useMemo(function () {
    if (ScheduleFilter.advancedCalendarActive && !props.noAdvanced) {
      return removedDuplicates(groupSchedules, schedules[userId]);
    }
  }, [groupSchedules, schedules[userId], ScheduleFilter.advancedCalendarActive, props.noAdvanced]);
  var groupScheduleData = useMemo(function () {
    return handleScheduleGroupData(ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : ScheduleFilter.userFilter);
  }, [ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : ScheduleFilter.userFilter]);

  var _eventsFactory = function _eventsFactory() {
    if (props.view == 'month') {
      return _getScheduleItemsForUser().map(function (item) {
        for (var _i2 = 0, _Object$entries2 = Object.entries(item); _i2 < _Object$entries2.length; _i2++) {
          var _count;

          var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
              key = _Object$entries2$_i[0],
              value = _Object$entries2$_i[1];

          var count = void 0;

          if (Array.isArray(value)) {
            count = countActivities(value);
          }

          return {
            id: key,
            title: key.toString(),
            length: (_count = count) !== null && _count !== void 0 ? _count : null,
            start: moment.utc(key).set({
              second: 0,
              millisecond: 0
            }).local().toDate(),
            end: moment.utc(key).set({
              second: 0,
              millisecond: 0
            }).local().add(60, 'minutes').toDate()
          };
        }
      });
    }

    return _getScheduleItemsForUser().map(function (item) {
      if ((item === null || item === void 0 ? void 0 : item.type) === 'custom_button') {
        return item;
      }

      return {
        id: item.id,
        title: item.title,
        instance: item === null || item === void 0 ? void 0 : item.instanceId,
        type: item.type,
        instanceType: item === null || item === void 0 ? void 0 : item.instanceType,
        start: moment.utc(item.startTime).set({
          second: 0,
          millisecond: 0
        }).local().toDate(),
        end: moment.utc(item.startTime).set({
          second: 0,
          millisecond: 0
        }).local().add(item.length, 'minutes').toDate()
      };
    });
  };

  var handleTimePosition = function handleTimePosition() {
    var button = document.querySelector('.calendarButton');
    var container = document.querySelector('.add-placeholder-button');

    if (button) {
      var _containerRef$current;

      var cords = button === null || button === void 0 ? void 0 : button.getBoundingClientRect();
      var width = container === null || container === void 0 ? void 0 : container.getBoundingClientRect(); //get width of timelineContainer

      var widthRef = containerRef === null || containerRef === void 0 ? void 0 : (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.getBoundingClientRect().width;
      var left, right; //Get distance from corner to button plus 0.1% padding

      var leftDistance = ((cords === null || cords === void 0 ? void 0 : cords.width) - width.width) / 2 * 0.9;
      right = window.innerWidth - (cords === null || cords === void 0 ? void 0 : cords.right);

      if (props.view === 'day') {
        left = cords === null || cords === void 0 ? void 0 : cords.left;
        setButtonCords({
          left: left,
          right: right,
          top: (cords === null || cords === void 0 ? void 0 : cords.top) + window.scrollY,
          margin: true
        });
        return;
      } //check if right corner of button plus innerElement plus 30 padding is greater than screenWidth


      if ((cords === null || cords === void 0 ? void 0 : cords.right) + widthRef + 30 > window.innerWidth) {
        //handle smaller screens
        if ((cords === null || cords === void 0 ? void 0 : cords.width) - width.width === 0) {
          left = (cords === null || cords === void 0 ? void 0 : cords.left) - (widthRef + (cords === null || cords === void 0 ? void 0 : cords.width));
        } else {
          left = (cords === null || cords === void 0 ? void 0 : cords.left) - widthRef - ((cords === null || cords === void 0 ? void 0 : cords.width) - width.width);
        }
      } else {
        //handle smaller screens
        if ((cords === null || cords === void 0 ? void 0 : cords.width) - width.width === 0) {
          left = (cords === null || cords === void 0 ? void 0 : cords.left) + (cords === null || cords === void 0 ? void 0 : cords.width) * 1.1;
        } else {
          left = (cords === null || cords === void 0 ? void 0 : cords.left) + (cords === null || cords === void 0 ? void 0 : cords.width) - leftDistance;
        }
      }

      setButtonCords({
        left: left,
        right: right,
        width: cords === null || cords === void 0 ? void 0 : cords.width,
        top: (cords === null || cords === void 0 ? void 0 : cords.top) + window.scrollY - width.height / 2,
        margin: false
      });
    }
  }; //handle resizing for timelineButton


  useEffect(function () {
    if (customButton) {
      handleTimePosition();
    }
  }, [props.windowWidth]);

  var toggleTimeButton = function toggleTimeButton() {
    setTimeButtonOpen(function (prev) {
      return !prev;
    });
  }; //reset advanced mode data whenever selected sections changes


  useEffect(function () {
    if (props !== null && props !== void 0 && props.advancedCalendar && !props.noAdvanced) {
      dispatch(clearActivitesForOther());
      setStoredFilterData([]);
      setOthersFilteredData([]);
      setStoredOtherSchedules([]);
      hasFetchedGroups.current.schedules = false;
      hasFetchedGroups.current.tasks = false;
    }

    setTimeButtonOpen(false);
  }, [props.view, props.date, props.advancedCalendar, ScheduleFilter.userFilter]); //main useEffect for filtering data

  useEffect(function () {
    var handleActivitesfiltering = function handleActivitesfiltering() {
      //remove timeline button
      setCustomButton([]);
      setTimeButtonOpen(false);

      if (ScheduleFilter.userFilter.length > 0) {
        finishedLoading.current = false;
      } else {
        finishedLoading.current = true;
      }

      var allowedTags = [];
      var shouldFilter = true;

      for (var _i3 = 0, _Object$entries3 = Object.entries(ScheduleFilter.activitiesFilter); _i3 < _Object$entries3.length; _i3++) {
        var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
            key = _Object$entries3$_i[0],
            value = _Object$entries3$_i[1];

        if (value) {
          allowedTags.push({
            name: key
          });
        }
      } //don't filter if all checkboxes are selected for select-activites


      if (Object.entries(ScheduleFilter.activitiesFilter).length === allowedTags.length && !ScheduleFilter.advancedCalendarActive) {
        shouldFilter = false;
      }

      if (allowedTags.length === 0) {
        setStoredFilterData([]);
        setOthersFilteredData([]);
        setStoredOtherSchedules([]);
      } //handle advancedcalendar data


      if (props !== null && props !== void 0 && props.advancedCalendar && allowedTags.length > 0 && !props.noAdvanced) {
        var _ScheduleFilter$userF;

        var filteredData = [];
        var schedule = [];
        var MyActivites = [];
        var filterOthers = [];
        var filterOthersFull = []; //display  my lessons if checkbox is checked and lesson are allowed to be displayed

        if (ScheduleFilter.activitiesFilter.Lesson && ScheduleFilter.displayMySchedule && schedules[userId]) {
          schedule = schedules[userId];
        } // handle noneOwned schedule items


        if (ScheduleFilter.activitiesFilter.Lesson && (groupScheduleData === null || groupScheduleData === void 0 ? void 0 : groupScheduleData.length) > 0) {
          var _schedules$userId, _combined2;

          var _combined;

          if (((_schedules$userId = schedules[userId]) === null || _schedules$userId === void 0 ? void 0 : _schedules$userId.length) > 0) {
            _combined = [].concat(_toConsumableArray(schedule), _toConsumableArray(groupSchedules));
          } else {
            _combined = [].concat(_toConsumableArray(schedules[userId]), _toConsumableArray(groupSchedules));
          }

          var _removeSame = (_combined2 = _combined) === null || _combined2 === void 0 ? void 0 : _combined2.filter(function (item, index, self) {
            return self.findIndex(function (t) {
              return t.id === item.id;
            }) === index;
          });

          var removeOwnedItems = groupSchedules.filter(function (item) {
            return !schedules[userId].find(function (f) {
              return f.id == (item === null || item === void 0 ? void 0 : item.id);
            });
          });

          if (props.view === 'month') {
            setStoredOtherSchedules(filterMonth(removeOwnedItems, props.date));
          } else {
            setStoredOtherSchedules(groupSchedules);
          }

          schedule = _removeSame;
        } //add my own activities to schedule if filters are selected


        if (activities.length > 0 && ScheduleFilter.displayMySchedule && shouldFilter) {
          MyActivites = filterArray(activities, ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : ScheduleFilter.activitiesFilter, allowedTags, ScheduleFilter.advancedCalendarActive);
        } else if (ScheduleFilter.displayMySchedule) {
          schedule = [].concat(_toConsumableArray(schedule), _toConsumableArray(activities));
        } // handle group activities


        if (((_ScheduleFilter$userF = ScheduleFilter.userFilter) === null || _ScheduleFilter$userF === void 0 ? void 0 : _ScheduleFilter$userF.length) > 0 && shouldFilter && (groupActivites === null || groupActivites === void 0 ? void 0 : groupActivites.length) > 0) {
          var _filteredData;

          filteredData = filterArray(groupActivites, ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : ScheduleFilter.activitiesFilter, allowedTags, ScheduleFilter.advancedCalendarActive);
          var findUnique = filteredData.filter(function (item) {
            return !activities.find(function (f) {
              return f.id == (item === null || item === void 0 ? void 0 : item.id);
            });
          });

          var _getMeetings = filteredData.filter(function (x) {
            return x.type === 'Meeting' && x.endTime !== '0001-01-01T00:00:00';
          });

          var removeSameFull = (_filteredData = filteredData) === null || _filteredData === void 0 ? void 0 : _filteredData.filter(function (item, index, self) {
            return self.findIndex(function (t) {
              return t.id === item.id && item.type !== 'Meeting';
            }) === index;
          });

          var _removeSame2 = findUnique === null || findUnique === void 0 ? void 0 : findUnique.filter(function (item, index, self) {
            return self.findIndex(function (t) {
              return t.id === item.id && t.type === item.type;
            }) === index;
          });

          filterOthers = [].concat(_toConsumableArray(_removeSame2), _toConsumableArray(_getMeetings)); // Filter booked meetings by instanceId

          var filterMeetings = _getMeetings.filter(function (item, index, self) {
            return self.findIndex(function (t) {
              return (t === null || t === void 0 ? void 0 : t.instanceId) == (item === null || item === void 0 ? void 0 : item.instanceId);
            }) === index;
          });

          filterOthersFull = [].concat(_toConsumableArray(removeSameFull), _toConsumableArray(filterMeetings));
        } else {
          filterOthers = [];
        }

        var combined = [].concat(_toConsumableArray(filteredData), _toConsumableArray(MyActivites));
        var getMeetings = combined.filter(function (t) {
          return t.type === 'Meeting';
        });
        var removeMeetingSame = getMeetings.filter(function (item, index, self) {
          return self.findIndex(function (t) {
            return (t === null || t === void 0 ? void 0 : t.instanceId) == (item === null || item === void 0 ? void 0 : item.instanceId);
          }) === index;
        });

        if (props.view == 'month') {
          var _removeSame3 = combined === null || combined === void 0 ? void 0 : combined.filter(function (item, index, self) {
            return self.findIndex(function (t) {
              return t.id === item.id && t.type === item.type && item.type !== 'Meeting';
            }) === index;
          });

          var _filterData = filterMonth([].concat(_toConsumableArray(_removeSame3), _toConsumableArray(schedule), _toConsumableArray(removeMeetingSame)), props.date);

          var otherFiltersData = filterMonth(filterOthers, props.date);
          setFilterData(_filterData);
          setOthersFilteredData(otherFiltersData);
          return;
        }

        var removeSame = combined === null || combined === void 0 ? void 0 : combined.filter(function (item, index, self) {
          return self.findIndex(function (t) {
            return t.id === item.id && t.type === item.type && item.type !== 'Meeting';
          }) === index;
        });
        setStoredFilterData([].concat(_toConsumableArray(removeSame), _toConsumableArray(schedule), _toConsumableArray(removeMeetingSame)));
        setOthersFilteredData(filterOthersFull);
        return;
      } //handle substitute teacher


      if (props.userId && !props.isStudentCard) {
        if (schedules[userId]) {
          setFilterData(schedules[userId]);

          if (props.view === 'month') {
            setFilterData(filterMonth(schedules[userId], props.date));
            return;
          }

          return;
        }

        setFilterData([]);
        return;
      } //handle normal calendar for logged in user


      if (allowedTags.length > 0) {
        var _schedules$userId2;

        var arr = [];

        if ((studentActivites === null || studentActivites === void 0 ? void 0 : studentActivites.length) > 0 && shouldFilter) {
          arr = filterArray(studentActivites, ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : ScheduleFilter.activitiesFilter, allowedTags, false, loggedInUser.isStudent());
        } else if (shouldFilter && !props.isStudentCard) {
          arr = filterArray(activities, ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : ScheduleFilter.activitiesFilter, allowedTags, false, loggedInUser.isStudent());
        } else {
          if (props.isStudentCard) {
            arr = studentActivites != null ? studentActivites : [];
          } else {
            arr = activities != null ? activities : [];
          }
        }

        if (ScheduleFilter.activitiesFilter.Lesson && ((_schedules$userId2 = schedules[userId]) === null || _schedules$userId2 === void 0 ? void 0 : _schedules$userId2.length) > 0) {
          arr = [].concat(_toConsumableArray(arr), _toConsumableArray(schedules[userId]));
        }

        if (props.view === 'month') {
          if (arr.length > 0) {
            setFilterData(filterMonth(arr, props.date));
            return;
          }
        }

        setFilterData(arr);
        return;
      }

      setFilterData([]);
    };

    handleActivitesfiltering();
  }, [ScheduleFilter.userFilter, activities, ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : ScheduleFilter.activitiesFilter, groupActivites, studentActivites, groupSchedules, schedules[userId]]);
  var formats = {
    weekdayFormat: function weekdayFormat(date, culture, localizer) {
      return localizer.format(date, 'dddd', culture);
    }
  }; //group dates under same date

  var handleClickCalendar = function handleClickCalendar(event) {
    if (props.view === 'month') {
      return;
    }

    if (timeButtonOpen) {
      setTimeButtonOpen(false);
    }

    var obj = {
      id: 'custom_button',
      startTime: event.start,
      end: moment.utc(event.start).set({
        second: 0,
        millisecond: 0
      }).local().add(60, 'minutes').toDate(),
      typ: 'custom_button'
    };
    setCustomButton([obj]);
  }; //handle only displayin others schedule for month view


  var handleMonthView = useMemo(function () {
    if (props.advancedCalendar && !ScheduleFilter.displayMySchedule && props.view === 'month') {
      var filterSchedules = filterMonth(groupSchedules, props.date);
      return [].concat(_toConsumableArray(othersFilteredData), _toConsumableArray(filterSchedules));
    }

    return [];
  }, [props.view, props.advancedCalendar, ScheduleFilter.displayMySchedule, groupSchedules, othersFilteredData]); //add data to calendar

  var _getScheduleItemsForUser = function _getScheduleItemsForUser() {
    var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var data = [];

    if (props.view == 'month') {
      if (!ScheduleFilter.displayMySchedule) {
        return handleMonthView;
      }

      return filterData;
    }

    if (ScheduleFilter.displayMySchedule) {
      if (props.advancedCalendar && !props.noAdvanced) {
        data = storedFilterData;
      } else {
        data = filterData;
      }
    } else if (!ScheduleFilter.displayMySchedule && props.advancedCalendar && !props.noAdvanced) {
      var _ScheduleFilter$activ;

      if (ScheduleFilter !== null && ScheduleFilter !== void 0 && (_ScheduleFilter$activ = ScheduleFilter.activitiesFilter) !== null && _ScheduleFilter$activ !== void 0 && _ScheduleFilter$activ.Lesson) {
        data = storedOtherSchedules;
      }

      data = [].concat(_toConsumableArray(data), _toConsumableArray(othersFilteredData));
    } else {
      data = filterData;
    } //add custom button to calendar as event


    if (customButton.length > 0) {
      data = [].concat(_toConsumableArray(data), _toConsumableArray(customButton));
    }

    return data;
  }; //Handle event style


  var _getEventProps = function _getEventProps(event, start, end, isSelected) {
    var _schedule$relationshi;

    var className = '';
    var style = {};

    var attendance = _getAttendanceForItem(event.id);

    var activites = _getActivitesForItem(event.id, event === null || event === void 0 ? void 0 : event.instance, event === null || event === void 0 ? void 0 : event.type);

    var schedule = _getScheduleItem(event.id, event === null || event === void 0 ? void 0 : event.type);

    var hasExamination = false;

    if (event.id === 'custom_button') {
      if (props.view === 'day') {
        className = 'calendarButton day';
      } else {
        className = 'calendarButton';
      }

      style.padding = 0;
      return {
        className: className,
        style: style
      };
    }

    if (timeButtonOpen && event.id !== 'custom_button') {
      style.backgroundColor = '#d0d0d0';
    } //don't change the size of events whenever the custom button is added


    if (event.id !== 'custom_button') {
      style.maxWidth = '90%';
      style.minWith = 'fit-content';
      style.minHeight = 'fit-content';
      style.borderStyle = 'solid';
    } //check if lesson has an assignment with a test connected


    if ((schedule === null || schedule === void 0 ? void 0 : (_schedule$relationshi = schedule.relationships) === null || _schedule$relationshi === void 0 ? void 0 : _schedule$relationshi.length) > 0 && service.advancedSchedule) {
      var findItems = schedule === null || schedule === void 0 ? void 0 : schedule.relationships.filter(function (x) {
        return x.instanceType === 'ASSIGNMENT_TYPE_WRITTEN_TEST' || x.instanceType === 'ASSIGNMENT_TYPE_VERBAL_TEST';
      });

      if (findItems.length > 0) {
        hasExamination = true;
      } //check if lesson is a test opportunity

    } else if (schedule !== null && schedule !== void 0 && schedule.examination && service.advancedSchedule) {
      hasExamination = true;
    }

    if (props.view == 'month') {
      style.backgroundColor = 'transparent';
      style.color = '#fff';
      return {
        className: className,
        style: style
      };
    }

    if (attendance != null && activites === null) {
      className += ' attendance';

      if (attendance.attendanceType == 'PRESENT') {
        //	style.borderLeftColor = '#19db6c';
        if (props.view != 'agenda') {
          style.backgroundColor = '#e8fbf0';
        }
      }

      if (attendance.type === 'Meeting' || attendance.type === 'assignment') {
        style.backgroundColor = '#fffff';
      }

      if (attendance.type.indexOf('VALID') > -1) {
        //style.borderLeftColor = '#efc24c';
        if (props.view != 'agenda') {
          style.backgroundColor = '#fff6df';
        }
      }

      if (attendance.type.indexOf('INVALID') > -1) {
        style.borderLeftColor = '#f25252';

        if (props.view != 'agenda') {
          style.backgroundColor = '#FDE5E5';
        }
      }
    } else if (activites != null) {
      style.borderLeftColor = '#b7b7b';

      if (activites.type === 'Assignment') {
        className += 'Assignment';
      }

      if (activites.notMine || !ScheduleFilter.displayMySchedule && ScheduleFilter.advancedCalendarActive && props.advancedCalendar) {
        className += " notOwner";

        if (activites.instanceType == 'ASSIGNMENT_TYPE_WRITTEN_TEST' || activites.instanceType == 'ASSIGNMENT_TYPE_VERBAL_TEST') {
          className += ' hasExamination';
        }

        if (activites.type === 'Meeting') {
          className += ' meeting';

          if (activites.instanceId == null) {
            className += ' no-booked';
          }
        }
      } else if (activites.type === 'Meeting') {
        className += ' meeting';

        if (activites.instanceId == null) {
          className += ' no-booked';
        }
      } else if (activites.instanceType == 'ASSIGNMENT_TYPE_WRITTEN_TEST' || activites.instanceType == 'ASSIGNMENT_TYPE_VERBAL_TEST') {
        className += ' hasExamination';
      }

      return {
        className: className,
        style: style
      }; //Handle lessons
    } else {
      var lesson = schedule;

      if (lesson != null && lesson.attendanceReported != null) {
        className += 'attendance';

        if (hasExamination) {
          className += ' hasExamination';
        }

        if (lesson !== null && lesson !== void 0 && lesson.notMine || !ScheduleFilter.displayMySchedule && ScheduleFilter.advancedCalendarActive && props.advancedCalendar) {
          className += " notOwner";
        }

        return {
          className: className,
          style: style
        };
      } else {
        className += ' lesson';
      }

      if (props.notOwner && (lesson === null || lesson === void 0 ? void 0 : lesson.attendanceReported) === null) {
        className += " notOwner";
      }

      if (hasExamination && lesson) {
        className += ' hasExamination';
      }

      if (lesson !== null && lesson !== void 0 && lesson.notMine || !ScheduleFilter.displayMySchedule && ScheduleFilter.advancedCalendarActive && props.advancedCalendar) {
        //style.backgroundColor = '#EDEDED';
        className += " notOwner";
      }

      if (timeButtonOpen && event.id !== 'custom_button') {
        style.backgroundColor = '#d0d0d0';
      }
    }

    return {
      className: className,
      style: style
    };
  };

  var _getScheduleItem = function _getScheduleItem(id) {
    var _schedules$userId3;

    var selectable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var type = arguments.length > 2 ? arguments[2] : undefined;
    var instanceId = arguments.length > 3 ? arguments[3] : undefined;

    if (id == null && type && !selectable) {
      return null;
    }

    if (selectable) {
      var _getScheduleItemsForU2;

      if (type === 'Meeting' && instanceId) {
        var _getScheduleItemsForU;

        return (_getScheduleItemsForU = _getScheduleItemsForUser()) === null || _getScheduleItemsForU === void 0 ? void 0 : _getScheduleItemsForU.find(function (item) {
          return item.instanceId == instanceId;
        });
      }

      return (_getScheduleItemsForU2 = _getScheduleItemsForUser()) === null || _getScheduleItemsForU2 === void 0 ? void 0 : _getScheduleItemsForU2.find(function (item) {
        return item.id == id;
      });
    }

    if (props.advancedCalendar && !props.noAdvanced) {
      var checkOthers = notOwnedSchedules === null || notOwnedSchedules === void 0 ? void 0 : notOwnedSchedules.find(function (item) {
        return item.id == id;
      });

      if (typeof checkOthers !== 'undefined') {
        checkOthers.notMine = true;
        return checkOthers;
      }
    }

    return (_schedules$userId3 = schedules[userId]) === null || _schedules$userId3 === void 0 ? void 0 : _schedules$userId3.find(function (item) {
      return item.id == id;
    });
  };

  var _getAttendanceForItem = function _getAttendanceForItem(id, type) {
    if (id == null) {
      return null;
    }

    if (attendance == null || attendance.length == 0) {
      return null;
    }

    if (userId === null) {
      return null;
    }

    return attendance.find(function (item) {
      return item.calendarEventId == id && item.user.userId == userId && item.attendanceType != 'NOT_REPORTED';
    });
  };

  var _getActivitesForItem = function _getActivitesForItem(id, instance, type) {
    if (id == null) {
      return null;
    }

    if (activities.length > 0 || groupActivites.length > 0) {
      if (type === 'Meeting') {
        if (instance) {
          if (props.advancedCalendar && !props.noAdvanced) {
            var _ScheduleFilter$userF2;

            var notOwned = notOwnedActivities.find(function (item) {
              return item.id === id && item.instanceId === instance;
            });
            var myActivities = activities.find(function (item) {
              return item.id === id && item.instanceId === instance;
            });
            var owned = groupActivites.find(function (item) {
              return item.id === id && item.instanceId === instance;
            });

            if (notOwned != null && typeof owned === 'undefined' && typeof myActivities === 'undefined') {
              notOwned.notMine = true;
              return notOwned;
            } else if (typeof owned !== 'undefined' && typeof myActivities === 'undefined' && (ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : (_ScheduleFilter$userF2 = ScheduleFilter.userFilter) === null || _ScheduleFilter$userF2 === void 0 ? void 0 : _ScheduleFilter$userF2.length) > 0) {
              return owned;
            }

            return activities.find(function (item) {
              return item.id === id && item.instanceId === instance;
            });
          }

          return activities.find(function (item) {
            return item.id === id && item.instanceId === instance;
          });
        } else {
          if (props.advancedCalendar && !props.noAdvanced) {
            var _ScheduleFilter$userF3;

            var _notOwned = othersFilteredData.find(function (item) {
              return item.id === id && item.instanceId === instance;
            });

            var _owned = groupActivites.find(function (item) {
              return item.id === id && item.instanceId === instance;
            });

            if (_notOwned != null) {
              _notOwned.notMine = true;
            }

            if (!ScheduleFilter.displayMySchedule) {
              return _notOwned;
            }

            if (typeof _notOwned !== 'undefined') {
              return _notOwned;
            } else if (typeof _owned !== 'undefined' && (ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : (_ScheduleFilter$userF3 = ScheduleFilter.userFilter) === null || _ScheduleFilter$userF3 === void 0 ? void 0 : _ScheduleFilter$userF3.length) > 0) {
              return _owned;
            } else {
              return activities.find(function (item) {
                return item.id === id && item.instanceId === instance;
              });
            }
          }

          return activities.find(function (item) {
            return item.id === id && item.instanceId === instance;
          });
        }
      }

      if (props.advancedCalendar && !props.noAdvanced) {
        var _ScheduleFilter$userF4;

        var _notOwned2 = notOwnedActivities.find(function (item) {
          return item.id === id;
        });

        var _owned2 = groupActivites.find(function (item) {
          return item.id === id;
        });

        var _myActivities = activities.find(function (item) {
          return item.id === id;
        });

        if (_notOwned2 != null) {
          _notOwned2.notMine = true;
          return _notOwned2;
        }

        if (_notOwned2 != null && typeof _owned2 === 'undefined' && typeof _myActivities === 'undefined') {
          _notOwned2.notMine = true;
          return _notOwned2;
        } else if (_owned2 && typeof _myActivities === 'undefined' && (ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : (_ScheduleFilter$userF4 = ScheduleFilter.userFilter) === null || _ScheduleFilter$userF4 === void 0 ? void 0 : _ScheduleFilter$userF4.length) > 0) {
          return _owned2;
        }

        return _myActivities;
      }

      if (props.isStudentCard) {
        return studentActivites.find(function (item) {
          return item.id === id;
        });
      }

      return activities.find(function (item) {
        return item.id === id;
      });
    }

    return null;
  };

  var _getStartEndDates = function _getStartEndDates() {
    var _props$view;

    var start,
        end = props.date;

    switch ((_props$view = props.view) !== null && _props$view !== void 0 ? _props$view : 'week') {
      case 'agenda':
      case 'day':
        start = moment(props.date).set({
          hour: 0,
          minute: 0,
          second: 0
        }).toISOString();
        end = moment(props.date).set({
          hour: 23,
          minute: 59,
          second: 59
        }).toISOString();
        break;

      case 'work_week':
        start = moment(props.date).weekday(0).set({
          hour: 0,
          minute: 0,
          second: 0
        }).toISOString();
        end = moment(props.date).weekday(5).set({
          hour: 23,
          minute: 59,
          second: 59
        }).toISOString();
        break;

      case 'week':
        start = moment(props.date).weekday(0).set({
          hour: 0,
          minute: 0,
          second: 0
        }).toISOString();
        end = moment(props.date).weekday(7).set({
          hour: 23,
          minute: 59,
          second: 59
        }).toISOString();
        break;

      case 'month':
        start = moment(props.date).startOf('month').set({
          hour: 0,
          minute: 0,
          second: 0
        }).toISOString();
        end = moment(props.date).endOf('month').set({
          hour: 23,
          minute: 59,
          second: 59
        }).toISOString();

      default:
        break;
    }

    return {
      start: start,
      end: end
    };
  };

  var _getTimeRange = function _getTimeRange() {
    var min = moment().set({
      hour: 6,
      minute: 0
    }).toDate();
    var max = moment().set({
      hour: 12,
      minute: 0
    }).toDate(); //Display entire day if button is active

    if (displayWholeDay) {
      min = moment().set({
        hour: 6,
        minute: 0
      }).toDate();
      max = moment().set({
        hour: 23,
        minute: 59
      }).toDate();
      return {
        min: min,
        max: max
      };
    }

    if (props.view !== 'month') {
      var _getStartEndDates2 = _getStartEndDates(),
          _start = _getStartEndDates2.start,
          _end = _getStartEndDates2.end;

      var scheduleItems = _getScheduleItemsForUser().filter(function (x) {
        return moment.utc(x.startTime).local() > moment(_start).utc().local() && moment.utc(x.startTime).local() < moment(_end).utc().local();
      });

      if (scheduleItems != null && (scheduleItems === null || scheduleItems === void 0 ? void 0 : scheduleItems.length) > 0) {
        var items = _toConsumableArray(scheduleItems);

        items.sort(function (a, b) {
          var date1 = moment.utc(a.startTime).local().minutes() + moment.utc(a.startTime).local().hours() * 60;
          var date2 = moment.utc(b.startTime).local().minutes() + moment.utc(b.startTime).local().hours() * 60;
          return date1 > date2 ? 1 : date2 > date1 ? -1 : 0;
        });
        var highest = scheduleItems.reduce(function (prev, current) {
          var now = moment().set({
            minutes: moment.utc(current.startTime).add(current.length, 'minutes').local().minutes(),
            hours: moment.utc(current.startTime).add(current.length, 'minutes').local().hours()
          });
          var last = moment().set({
            minutes: moment.utc(prev.startTime).add(prev.length, 'minutes').local().minutes(),
            hours: moment.utc(prev.startTime).add(prev.length, 'minutes').local().hours()
          });
          return last.unix() > now.unix() ? prev : current;
        });

        var _start2 = moment.utc(items[0].startTime).local().set({
          minute: 0
        });

        var _end2 = moment.utc(highest.startTime).local().add(highest.length, 'minutes').set({
          date: _start2.get('date'),
          month: _start2.get('month')
        });

        var diff = _end2.diff(_start2, 'hours');

        min = _start2.toDate();
        max = _end2.toDate();

        if (min > max) {
          min = moment().set({
            hour: 6,
            minute: 0
          }).toDate();
          max = moment().set({
            hour: 12,
            minute: 0
          }).toDate();
          return {
            min: min,
            max: max
          };
        }

        if (diff < 0) {
          min = moment().set({
            hour: 6,
            minute: 0
          }).toDate();
          max = moment().set({
            hour: 12,
            minute: 0
          }).toDate();
        }

        if (diff < 3) {
          if (moment(_start2).subtract(1, 'hour').isSame(_start2, 'day')) {
            min = _start2.subtract(1, 'hour').toDate();
          }

          if (moment(_end2).add(2, 'hours').isSame(_end2, 'day')) {
            max = _end2.add(2, 'hours').toDate();
          }
        }
      }
    }

    return {
      min: min,
      max: max
    };
  };

  var onSelectEvent = function onSelectEvent(slot) {
    var task = _getScheduleItem(slot.id, true, slot === null || slot === void 0 ? void 0 : slot.type, slot === null || slot === void 0 ? void 0 : slot.instance);

    if (slot.id == 'custom_button') {
      return;
    }

    if (task == null) {
      return false;
    }

    if (task !== null && task !== void 0 && task.type) {
      if (task.type === 'Meeting') {
        var url;

        if ((task === null || task === void 0 ? void 0 : task.instanceId) != null) {
          url = "".concat(getRootUrl(), "meeting/").concat(task.id, "/instance/").concat(task.instanceId);
        } else {
          url = "".concat(getRootUrl(), "meeting/").concat(task.id);
        }

        history.push(url);
        return;
      }

      if (task.type === 'Assignment') {
        var _url = "".concat(getRootUrl(), "assignment/").concat(task.id);

        history.push(_url);
        return;
      }
    }

    if (task.linkedSchedulePositions != null) {
      setLinkedPosition(task);
    } else {
      var _url2 = "".concat(getRootUrl(), "lesson/").concat(task.id);

      if (props.redirect != null) {
        _url2 += "?redirect=".concat(props.redirect);
      }

      history.push(_url2);
    }
  };

  var renderEventTitle = function renderEventTitle(event) {
    var lesson = _getScheduleItem(event.id);

    var attendance = _getAttendanceForItem(event.id);

    var activities = _getActivitesForItem(event.id, event.instance, event.type);

    return /*#__PURE__*/React.createElement(ItemContent, {
      lesson: lesson,
      event: event,
      activities: activities,
      attendance: attendance,
      view: props.view,
      open: timeButtonOpen,
      toggleTimeButton: toggleTimeButton
    });
  };

  useEffect(function () {
    if ((customButton === null || customButton === void 0 ? void 0 : customButton.length) > 0) {
      var button = document.querySelector('.calendarButton');

      if (button) {
        button.style.left = '0px';
        button.style.right = '0';
        button.style.width = '110%';
        handleTimePosition();
      }
    }
  }, [customButton, displayWholeDay]); //handle gray overlay background

  useEffect(function () {
    if (props.view !== 'month') {
      var calendarClass = document.querySelector('.rbc-time-content');

      if (calendarClass && timeButtonOpen && customButton) {
        calendarClass === null || calendarClass === void 0 ? void 0 : calendarClass.classList.toggle('overlay');
      } else {
        calendarClass === null || calendarClass === void 0 ? void 0 : calendarClass.classList.remove('overlay');
      }
    }
  }, [timeButtonOpen]);
  useEffect(function () {
    var _getStartEndDates3 = _getStartEndDates(),
        start = _getStartEndDates3.start,
        end = _getStartEndDates3.end; // start = moment(start).utc().toISOString();
    // end = moment(end).utc().toISOString();


    setFilterData([]);

    if (props.advancedCalendar && service.advancedSchedule && !props.noAdvanced && school.type != PRESCHOOL && currentUser !== null) {
      setIsLoading(true);
      dispatch(getScheduleForUser(currentUser.id, start, end));
      dispatch(getActivitiesForMe(start, end)).then(function () {
        if (finishedLoading.current) {
          setIsLoading(false);
        }
      });
      return;
    }

    if (props.userId != null) {
      setIsLoading(true);
      dispatch(getUserAttendance(props.userId, start, end));

      if (props.isStudentCard && service.advancedSchedule && school.type != PRESCHOOL) {
        dispatch(getActivitiesById(props.userId, start, end));
      }

      dispatch(getScheduleForUser(props.userId, start, end)).then(function () {
        setIsLoading(false);
      }); //handle only my own schedule
    } else if (!props.advancedCalendar && currentUser !== null) {
      //if user doesn't have the service for the advanced calendar don't fetch activities
      setIsLoading(true);

      if (service.advancedSchedule && school.type != PRESCHOOL) {
        var user = new User(props.user);

        if (user.isStudent()) {
          dispatch(getUserAttendance(currentUser.id, start, end));
        }

        dispatch(getActivitiesForMe(start, end));
        dispatch(getScheduleForUser(currentUser.id, start, end)).then(function () {
          setIsLoading(false);
        });
      } else {
        dispatch(getScheduleForUser(currentUser.id, start, end)).then(function () {
          setIsLoading(false);
        });
      }
    }
  }, [currentUser, props.date, props.view, props.userId]); //allow refetching of my own data again if disabled

  useEffect(function () {
    setCustomButton([]);
    hasFetcheMySchedule.current.schedules = false;
    hasFetcheMySchedule.current.tasks = false;
  }, [props.view, props.date, props.advancedCalendar]); //handle advanced calendarData data fetching

  useEffect(function () {
    var _getStartEndDates4 = _getStartEndDates(),
        start = _getStartEndDates4.start,
        end = _getStartEndDates4.end;

    start = moment(start).utc().toISOString();
    end = moment(end).utc().toISOString();

    if (props.advancedCalendar && service.advancedSchedule && !props.noAdvanced && school.type != PRESCHOOL) {
      var _ScheduleFilter$activ2, _ScheduleFilter$activ3;

      if (ScheduleFilter.userFilter.length == 0) {
        return;
      }

      setIsLoading(true);

      if ((_ScheduleFilter$activ2 = ScheduleFilter.activitiesFilter) !== null && _ScheduleFilter$activ2 !== void 0 && _ScheduleFilter$activ2.Assignment || (_ScheduleFilter$activ3 = ScheduleFilter.activitiesFilter) !== null && _ScheduleFilter$activ3 !== void 0 && _ScheduleFilter$activ3.Meeting) {
        var _ScheduleFilter$userF5;

        if (((_ScheduleFilter$userF5 = ScheduleFilter.userFilter) === null || _ScheduleFilter$userF5 === void 0 ? void 0 : _ScheduleFilter$userF5.length) > 0 && !hasFetchedGroups.current.tasks) {
          dispatch(getActivitesForGroups(start, end, ScheduleFilter.userFilter)).then(function () {
            if (!ScheduleFilter.activitiesFilter.Lesson) {
              setIsLoading(false);
            }

            hasFetchedGroups.current.tasks = true;
          });
        }
      }

      if (ScheduleFilter.activitiesFilter.Lesson && groupScheduleData.length > 0 && !hasFetchedGroups.current.schedules) {
        dispatch(getScheduleForGroups(start, end, groupScheduleData)).then(function () {
          setIsLoading(false);
          hasFetchedGroups.current.schedules = true;
        });
      }
    }
  }, [ScheduleFilter.userFilter, props.date, props.view, props.advancedCalendar, ScheduleFilter.activitiesFilter]);
  useEffect(function () {
    return function () {
      dispatch(clearUserAttendance());
    };
  }, []);

  var _getStartEndDates5 = _getStartEndDates(),
      start = _getStartEndDates5.start,
      end = _getStartEndDates5.end;

  var _getTimeRange2 = _getTimeRange(),
      min = _getTimeRange2.min,
      max = _getTimeRange2.max;

  var containerClassName = 'c--schedule';

  if (props.userId != null && currentUser != null) {
    if (props.userId != currentUser.id) {
      containerClassName += ' variant-striped';
    }
  }

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: containerClassName
  }, linkedPosition != null && linkedPosition !== null && linkedPosition !== void 0 && linkedPosition.section ? /*#__PURE__*/React.createElement(SelectLinkedPosition, {
    lesson: linkedPosition,
    onClose: function onClose() {
      return setLinkedPosition(null);
    }
  }) : null, /*#__PURE__*/React.createElement(SelectionDisplay, {
    date: props.date,
    start: start,
    end: end,
    isLoading: isLoading,
    view: props.view
  }), /*#__PURE__*/React.createElement(Calendar, {
    localizer: localizer,
    events: _eventsFactory(),
    eventPropGetter: _getEventProps,
    startAccessor: "start",
    endAccessor: "end",
    date: props.date != null ? props.date.toDate() : moment().toDate(),
    view: (_props$view2 = props.view) !== null && _props$view2 !== void 0 ? _props$view2 : 'work_week',
    views: ['work_week', 'week', 'day', 'month', 'agenda'],
    toolbar: false,
    min: min,
    max: max,
    formats: props.view == 'month' ? formats : {
      dayFormat: function dayFormat(date, culture, localizer) {
        return localizer.format(date, 'dddd D/M', culture).capitalize();
      }
    },
    messages: {
      noEventsInRange: /*#__PURE__*/React.createElement("span", {
        style: {
          display: 'block'
        },
        className: "color--meta text--center weight--bold"
      }, translate('no-schedule-for-today'))
    },
    titleAccessor: renderEventTitle,
    onSelectEvent: onSelectEvent,
    onView: function onView() {
      return true;
    },
    onNavigate: function onNavigate() {
      return true;
    },
    selectable: !loggedInUser.isStudent() && props.userId === null && service.advancedSchedule ? true : false,
    components: {
      month: {
        header: MonthHeader
      }
    },
    onSelectSlot: handleClickCalendar,
    dayLayoutAlgorithm: "no-overlap"
  }), props.view !== 'month' && !loggedInUser.isStudent() && !props.userId ? /*#__PURE__*/React.createElement("div", {
    className: "DayDisplayer"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "no_background",
    style: {
      marginLeft: 0,
      marginRight: '0.5em'
    },
    onClick: function onClick() {
      return setDisplayWholeDay(function (prev) {
        return !prev;
      });
    }
  }, !displayWholeDay ? /*#__PURE__*/React.createElement("div", null, translate('Display-whole-day')) : /*#__PURE__*/React.createElement("div", null, translate('Display-less')))) : null), props.view !== 'month' && /*#__PURE__*/React.createElement("div", {
    className: timeButtonOpen ? 'timeLineOpen' : 'timeLineOpen notVisible',
    ref: containerRef,
    style: {
      position: 'absolute',
      left: buttonCoords === null || buttonCoords === void 0 ? void 0 : buttonCoords.left,
      top: buttonCoords === null || buttonCoords === void 0 ? void 0 : buttonCoords.top,
      right: buttonCoords === null || buttonCoords === void 0 ? void 0 : buttonCoords.right,
      margin: buttonCoords !== null && buttonCoords !== void 0 && buttonCoords.margin ? '3em auto' : 'auto'
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      var _customButton$;

      return props === null || props === void 0 ? void 0 : props.scheduleButtons('create-lesson', (_customButton$ = customButton[0]) === null || _customButton$ === void 0 ? void 0 : _customButton$.startTime);
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    name: "Calendar_bw"
  })), /*#__PURE__*/React.createElement("span", {
    className: "timeline_title"
  }, translate('Lesson'))), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      var _customButton$2;

      return props === null || props === void 0 ? void 0 : props.scheduleButtons('Create assignment', (_customButton$2 = customButton[0]) === null || _customButton$2 === void 0 ? void 0 : _customButton$2.startTime);
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    name: "assignment"
  })), /*#__PURE__*/React.createElement("span", {
    className: "timeline_title"
  }, translate('Assignment'))), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      var _customButton$3;

      return props === null || props === void 0 ? void 0 : props.scheduleButtons('Create group assignment', (_customButton$3 = customButton[0]) === null || _customButton$3 === void 0 ? void 0 : _customButton$3.startTime);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "Assignment_Group_icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Assignment_Group"
  })), /*#__PURE__*/React.createElement("span", {
    className: "timeline_title"
  }, translate('group-assignment')))));
};

export default ScheduleView;